var moduleMap = {
	"./App": function() {
		return Promise.all([__webpack_require__.e(592), __webpack_require__.e(745), __webpack_require__.e(874), __webpack_require__.e(437), __webpack_require__.e(82), __webpack_require__.e(323), __webpack_require__.e(624), __webpack_require__.e(439), __webpack_require__.e(362), __webpack_require__.e(735), __webpack_require__.e(309), __webpack_require__.e(951), __webpack_require__.e(257), __webpack_require__.e(476), __webpack_require__.e(236)]).then(function() { return function() { return (__webpack_require__(9555)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});